import { selectors } from 'app-webtech-core/selectors';

const urlProtocolRegex = /^(http|https):\/\//i;

const prependApiBaseUrl = (endpoint, keepProtocol, state) => {
  const API_BASE_URL = selectors.application.servers(state).api;
  if (!endpoint) {
    return endpoint;
  }

  if (urlProtocolRegex.test(endpoint) && !keepProtocol) {
    return endpoint.replace(urlProtocolRegex, '//');
  }

  if (!urlProtocolRegex.test(endpoint)) {
    return `${API_BASE_URL}${endpoint}`.replace(urlProtocolRegex, '//');
  }

  return endpoint;
};

export default prependApiBaseUrl;
